export const CACHE_CONFIG = {
  localStorageDefaultMinutes: 5,
};

export const STOCK_DETAIL_CONFIG = {
  refreshIntervalMinutes: 5,
};

export const EARNINGS_CALENDAR_CONFIG = {
  defaultDaysAhead: 10,
};

export const AUTO_TRADING_CONFIG = {
  rulesRefreshMinutes: 30,
};
